
document.addEventListener('DOMContentLoaded', function () {
    if (!p80.manuals) return;

    const listEl = $('.pdf-links');

    $.each(p80.manuals, function (index, item) {
        let links = [];

        if (item.file_1 != undefined) links.push(`<a href="${item.file_1}" target="_blank" rel="noopener noreferrer"><span>Download 1</span></a>`);
        if (item.file_2 != undefined) links.push(`<a href="${item.file_2}" target="_blank" rel="noopener noreferrer"><span>Download 2</span></a>`);

        if (links.length) links = links.join(' | ');

        const entry = `<div class="link">
            <div class="title">${item.title}</div>
            <div class="links">${links}</div>
        </div>`;
        listEl.append(entry);
    })
});